import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AppWrapper from "./App"; // 確保 App.tsx 匯出的組件名稱是 AppWrapper
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <AppWrapper /> {/* 確保這裡是包含 <Router> 的組件 */}
  </React.StrictMode>
);

reportWebVitals();
